import React, { FC } from 'react';

import { IAdvInfo } from '../../assets/interfaces/advantageInterface/index';
import NextImage from '../UI/nextImage/NextImage';
import { Title } from '../UI/title/Title';

import styles from './AdvantageList.module.scss';

type TAdvList = {
    advList: IAdvInfo[];
};

const AdvantageList: FC<TAdvList> = ({ advList }) => {
    return (
        <ul className={styles.adv__list}>
            {advList.map((item, i) => {
                return (
                    <li className={`${styles.adv__item}`} key={`${item.advName}-${i}`}>
                        <div className={styles.logo}>
                            <div className={styles.logo__wrapper}>
                                <NextImage
                                    src={item.advLogo}
                                    alt={item.advAlt}
                                    fill
                                    sizes="(max-width: 480px) 24px, 32px"
                                />
                            </div>
                        </div>
                        <Title text={item.advName} size="xs" className={styles.name} />

                        <p className={`excerpt body-md ${styles.excerpt}`}>{item.advDescr}</p>
                    </li>
                );
            })}
        </ul>
    );
};

export default AdvantageList;
